module.exports = __webpack_public_path__ + "img/regalos.92e19079.png";